import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import ReserveMenuCategoryEdit from './ReserveMenuCategoryEdit';
import { SocketContext } from '../../../App';
import { useContext, useEffect, useRef } from 'react';
import { Switch } from 'antd';

export default function ReserveMenuCategory(props: any) {

    const ref = useRef<any>(undefined);
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    /** api服务id */
    const apiId = 'reserveMenuCategory';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        //同步获取数据 async - await
        const fetchData = async () => {

        };

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    const onRefresh = (item: any) => {
        const { branchStoreId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                branchStoreId
            }
        }
        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }

    //表头
    const columnsHead = [
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.branchStore.brand.brandName + " " + record.branchStore.branchStoreName}</div>
                )
            }
        },
        {
            title: '预订菜单分类',
            dataIndex: 'reserveMenuCategoryName',
        },
        {
            title: '预订菜单分类英文',
            dataIndex: 'reserveMenuCategoryNameEn',
        },
        {
            title: '专属id(简码)',
            dataIndex: 'selfId',
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
        {
            title: '默认分类',
            dataIndex: 'isDefault',
            render: (text: any, record: any) => {
                return (
                    <Switch checkedChildren="是" unCheckedChildren="否"
                        checked={text} key={record.id}
                    />
                )
            }
        }
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '预订菜单分类',
        apiId: 'reserveMenuCategory',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: ReserveMenuCategoryEdit,
        sendPageData: {
            branchStoreId: contextData?.currentBranchStoreId
        },
    };

    return (
        <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
    )
}